let socket = null;
let currentGroup = null;
let reconnectTimeout = null;

function getWebSocketUrl(groupName) {
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${window.location.host}/ws/htmx-component/${groupName}/`;
}

function handleHtmxComponentMessage(data) {
  const { action, target, html, id } = data;
  switch (action) {
    case "refresh": {
      const element = document.querySelector(target);
      if (element) {
        window.htmx.trigger(element, "ws-refresh");
      }
      break;
    }
    case "replace": {
      const element = document.querySelector(target);
      if (element) {
        element.innerHTML = html;
      }
      break;
    }
    case "append": {
      const element = document.querySelector(target);
      if (element) {
        element.insertAdjacentHTML("beforeend", html);
      }
      break;
    }
    case "prepend": {
      const element = document.querySelector(target);
      if (element) {
        element.insertAdjacentHTML("afterbegin", html);
      }
      break;
    }
    case "remove": {
      const element = document.getElementById(id);
      if (element) {
        element.remove();
      }
      break;
    }
  }
}

function connectHtmxComponentWebSocket(groupName) {
  if (socket && currentGroup === groupName) {
    return;
  }
  disconnectHtmxComponentWebSocket();

  currentGroup = groupName;
  const url = getWebSocketUrl(groupName);
  socket = new WebSocket(url);

  socket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      handleHtmxComponentMessage(data);
    } catch (e) {
      // ignore malformed messages
    }
  };

  socket.onclose = () => {
    socket = null;
    if (currentGroup === groupName) {
      reconnectTimeout = setTimeout(() => {
        connectHtmxComponentWebSocket(groupName);
      }, 3000);
    }
  };
}

function disconnectHtmxComponentWebSocket() {
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout);
    reconnectTimeout = null;
  }
  currentGroup = null;
  if (socket) {
    socket.close();
    socket = null;
  }
}

export function bindHtmxComponentWebSocket() {
  const element = document.querySelector("[data-ws-group]");
  if (element) {
    connectHtmxComponentWebSocket(element.dataset.wsGroup);
  } else {
    disconnectHtmxComponentWebSocket();
  }
}
